// Types
import { ProductProps } from 'types/Product.types';

const hasProductTypes = (items: ProductProps[], requiredTypes: string[]): boolean => {
  const typesInBasket = new Set(items.map((item) => item.productType));

  return requiredTypes.every((type) => typesInBasket.has(type));
};

export default hasProductTypes;
